import React from 'react';
import { useState } from "react"

import PropertyHeader from "./global-components/Property-header"
import SearchGridNew from "./section-components/search-gridnew"

const MainGridComponent = () =>{
        const [newPropertyHeader , setNewPropertyHeader] = useState([])

    return(
        <>
        {/* <PageHeader headertitle="Properties" subheader="Properties" /> */}
        <PropertyHeader headertitle="Properties" subheader="Properties" setNewPropertyHeader={setNewPropertyHeader} newPropertyHeader={newPropertyHeader} />
        {/* <SearchGridSection /> */}
        < SearchGridNew newPropertyHeader={newPropertyHeader} />
        <div style={{paddingBottom : '35px'}}></div>
    </>
    )
}

export default MainGridComponent